module.exports = __webpack_public_path__ + "static/img/home_cajasrefrigeradas.9b45a49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home_cajasrefrigeradas.png
// module id = 79
// module chunks = 0